import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import type { FavoriteTargetType } from "@compass/shared/schema/favorite";

interface TrendingLinkProps {
    type: FavoriteTargetType;
    id: number;
    className?: string;
    children: ReactNode;
}

/**
 * Renders a typed TanStack Router <Link> for each content type.
 * Falls back to a plain <div> for types without a direct detail route.
 */
export const TrendingLink = ({ type, id, className, children }: TrendingLinkProps) => {
    switch (type) {
        case "post":
            return (
                <Link to="/social/post/$id" params={{ id: String(id) }} className={className}>
                    {children}
                </Link>
            );
        case "blogPost":
            return (
                <Link to="/c/$slug" params={{ slug: "blog" }} className={className}>
                    {children}
                </Link>
            );
        case "chart":
            return (
                <Link to="/visualizations/$id" params={{ id: String(id) }} className={className}>
                    {children}
                </Link>
            );
        case "event":
            return (
                <Link to="/events/$id" params={{ id: String(id) }} className={className}>
                    {children}
                </Link>
            );
        case "compassEvent":
            return (
                <Link to="/private-events" className={className}>
                    {children}
                </Link>
            );
        case "vendor":
            return (
                <Link to="/vendors/$id" params={{ id: String(id) }} className={className}>
                    {children}
                </Link>
            );
        case "feedArticle":
            return (
                <Link to="/rss-feeds" className={className}>
                    {children}
                </Link>
            );
        case "sitewideSummary":
            return (
                <Link to="/digest/$id" params={{ id: String(id) }} className={className}>
                    {children}
                </Link>
            );
        default:
            return <div className={className}>{children}</div>;
    }
};
